import { reactive } from 'vue';
import buildMediaQuery from './buildMediaQuery';
import defaultScreens from './defaults/screens.json';
import { isUndefined, mapValues, toPairs, has } from './_';

let isSettingUp = false;
const screensState = reactive({
  matches: [],
  queries: {},
});

const removeQueryListener = (query, callback) => {
  if (query.removeEventListener) {
    query.removeEventListener('change', callback);
    return;
  }
  query.removeListener(callback);
};

const addQueryListener = (query, callback) => {
  if (query.addEventListener) {
    query.addEventListener('change', callback);
    return;
  }
  query.addListener(callback);
};

const refreshMatches = () => {
  screensState.matches = toPairs(screensState.queries)
    .filter(p => p[1].matches)
    .map(p => p[0]);
};

const refreshQueries = screens => {
  Object.values(screensState.queries).forEach(query => {
    removeQueryListener(query, refreshMatches);
  });

  screensState.queries = mapValues(screens, value => {
    const query = window.matchMedia(buildMediaQuery(value));
    addQueryListener(query, refreshMatches);
    return query;
  });

  refreshMatches();
};

export function setupScreens(screens = defaultScreens, forceSetup) {
  if (typeof window === 'undefined') {
    return;
  }

  if ((Object.keys(screensState.queries).length && !forceSetup) || isSettingUp) {
    return;
  }

  isSettingUp = true;
  refreshQueries(screens);
  isSettingUp = false;
}

export const screensMixin = {
  computed: {
    $screens() {
      return (config, def) =>
        screensState.matches.reduce(
          (prev, curr) => (has(config, curr) ? config[curr] : prev),
          isUndefined(def) ? config.default : def,
        )
    },
  },
};
